import React, { useState } from 'react'

const useModalPrice = () => {
    const [isModalOpenPrice, setModalOpenPrice] = useState(false);
    const openModalPrice = () => {
      setModalOpenPrice(true);
    };
  
    const closeModalPrice = () => {
      setModalOpenPrice(false);
    };


    return{
        isModalOpenPrice,
        setModalOpenPrice,
        closeModalPrice,
        openModalPrice,

    }
}


export default useModalPrice